module.exports = __webpack_public_path__ + "static/media/qhrdy.e3abd86f.mp4";